/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InactiveEventInfo_eventInfo$ref: FragmentReference;
declare export opaque type InactiveEventInfo_eventInfo$fragmentType: InactiveEventInfo_eventInfo$ref;
export type InactiveEventInfo_eventInfo = {|
  +noMainSearchText: ?string,
  +participantUser: ?boolean,
  +secondFactorType: ?{|
    +type: ?string
  |},
  +$refType: InactiveEventInfo_eventInfo$ref,
|};
export type InactiveEventInfo_eventInfo$data = InactiveEventInfo_eventInfo;
export type InactiveEventInfo_eventInfo$key = {
  +$data?: InactiveEventInfo_eventInfo$data,
  +$fragmentRefs: InactiveEventInfo_eventInfo$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "InactiveEventInfo_eventInfo",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "noMainSearchText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "participantUser",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "secondFactorType",
      "storageKey": null,
      "args": null,
      "concreteType": "SecondFactorType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "type",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bd6afe310e813ab00d73a380226e78e8';

module.exports = node;
